export const LOAD_LOGIN_PAGE_CONFIG = 'LOAD_LOGIN_PAGE_CONFIG';
export const LOAD_LOGIN_PAGE_CONFIG_SUCCESS = 'LOAD_LOGIN_PAGE_CONFIG_SUCCESS';
export const LOAD_LOGIN_PAGE_CONFIG_FAIL = 'LOAD_LOGIN_PAGE_CONFIG_FAIL';
